import {
  IBrand,
  IBrandRes,
  ICatalog,
  ICatalogRes,
  IFrm,
  IFrmRes,
  INews,
  INewsRes,
  ICommunity,
  ICommunityRes,
  IPrice,
  IPriceRes,
  IMerchant,
  IMerchantRes,
  IFarmerImages,
  ICommunityImages,
  IUploadImageRes,
  IUploadCommunityImageReq,
  IUploadFarmerImageReq,
} from '@/interfaces/master';
import * as baseAdapter from './baseAdapter';

export const searchBrands = async () => {
  const ret = await baseAdapter.get<IBrandRes>('/v1/brand/get-brand-list');
  return ret?.data;
};

export const getFarmer = async () => {
  const ret = await baseAdapter.get<IFrmRes>('/v1/farmer/GetFarmer');
  return ret?.data;
};

export const addFarmer = async (data: Partial<IFrm>) => {
  const ret = await baseAdapter.post<any>('/v1/farmer/CreateFarmer', data);
  return ret?.data;
};

export const updateFarmer = async (data: Partial<IFrm>) => {
  const ret = await baseAdapter.post('/v1/farmer/UpdateFarmer', data);
  return ret?.data;
};

export const deleteFarmer = async (data: Partial<IFrm>) => {
  const ret = await baseAdapter.post<any>('/v1/farmer/DeleteFarmer', data);
  return ret?.data;
};

export const getLand = async () => {
  const ret = await baseAdapter.get<IFrmRes>('/v1/land/GetLand');
  return ret?.data;
};

export const addLand = async (data: Partial<IFrm>) => {
  const ret = await baseAdapter.post<any>('/v1/land/CreateLand', data);
  return ret?.data;
};

export const updateLand = async (data: Partial<IFrm>) => {
  const ret = await baseAdapter.post('/v1/land/UpdateLand', data);
  return ret?.data;
};

export const deleteLand = async (data: Partial<IFrm>) => {
  const ret = await baseAdapter.post<any>('/v1/land/DeleteLand', data);
  return ret?.data;
};

export const getCrop = async () => {
  const ret = await baseAdapter.get<IFrmRes>('/v1/crop/GetCrop');
  return ret?.data;
};

export const addCrop = async (data: Partial<IFrm>) => {
  const ret = await baseAdapter.post<any>('/v1/crop/CreateCrop', data);
  return ret?.data;
};

export const updateCrop = async (data: Partial<IFrm>) => {
  const ret = await baseAdapter.post('/v1/crop/UpdateCrop', data);
  return ret?.data;
};

export const deleteCrop = async (data: Partial<IFrm>) => {
  const ret = await baseAdapter.post<any>('/v1/crop/DeleteCrop', data);
  return ret?.data;
};

export const getFarm = async () => {
  const ret = await baseAdapter.get<IFrmRes>('/v1/land/GetFarm');
  return ret?.data;
};

export const addFarm = async (data: Partial<IFrm>) => {
  const ret = await baseAdapter.post<any>('/v1/land/CreateFarm', data);
  return ret?.data;
};

export const updateFarm = async (data: Partial<IFrm>) => {
  const ret = await baseAdapter.post('/v1/land/UpdateFarm', data);
  return ret?.data;
};

export const deleteFarm = async (data: Partial<IFrm>) => {
  const ret = await baseAdapter.post<any>('/v1/land/DeleteFarm', data);
  return ret?.data;
};

export const getImages = async () => {
  const ret = await baseAdapter.get<IUploadImageRes>('/v1/image/GetImage');
  return ret?.data;
};

export const uploadCommunityImage = async (
  data: Partial<IUploadCommunityImageReq>,
) => {
  const ret = await baseAdapter.post<any>(
    '/v1/community/UploadCommunityImage',
    data,
  );
  return ret?.data;
};

export const uploadFarmerImage = async (
  data: Partial<IUploadFarmerImageReq>,
) => {
  const ret = await baseAdapter.post('/v1/farmer/UploadFarmerImage', data);
  return ret?.data;
};

export const getNews = async () => {
  const ret = await baseAdapter.get<INewsRes>('/v1/news/GetNews');
  return ret?.data;
};

export const addNews = async (data: Partial<INews>) => {
  const ret = await baseAdapter.post<any>('/v1/news/CreateNews', data);
  return ret?.data.data[0];
};

export const updateNews = async (data: Partial<INews>) => {
  const ret = await baseAdapter.post('/v1/news/UpdateNews', data);
  return ret?.data;
};

export const deleteNews = async (data: Partial<INews>) => {
  const ret = await baseAdapter.post<any>('/v1/news/DeleteNews', data);
  return ret?.data;
};

export const getCommunity = async () => {
  const ret = await baseAdapter.get<ICommunityRes>(
    '/v1/community/GetCommunity',
  );
  return ret?.data;
};

export const addCommunity = async (data: Partial<ICommunity>) => {
  const ret = await baseAdapter.post<any>(
    '/v1/community/CreateCommunity',
    data,
  );
  return ret?.data?.data[0];
};

export const updateCommunity = async (data: Partial<ICommunity>) => {
  const ret = await baseAdapter.post('/v1/community/UpdateCommunity', data);
  return ret?.data;
};

export const deleteCommunity = async (data: Partial<ICommunity>) => {
  const ret = await baseAdapter.post<any>(
    '/v1/community/DeleteCommunity',
    data,
  );
  return ret?.data;
};

export const getPrice = async () => {
  const ret = await baseAdapter.get<IPriceRes>('/v1/price/GetPrice');
  return ret?.data;
};

export const addPrice = async (data: Partial<IPrice>) => {
  const ret = await baseAdapter.post<any>('/v1/price/CreatePrice', data);
  return ret?.data?.data[0];
};

export const updatePrice = async (data: Partial<IPrice>) => {
  const ret = await baseAdapter.post('/v1/price/UpdateAveragePrice', data);
  return ret?.data;
};

export const deletePrice = async (data: Partial<IPrice>) => {
  const ret = await baseAdapter.post<any>('/v1/price/DeletePrice', data);
  return ret?.data;
};

export const getMerchant = async () => {
  const ret = await baseAdapter.get<IMerchantRes>('/v1/merchant/GetMerchants');
  return ret?.data;
};

export const addMerchant = async (data: Partial<IMerchant>) => {
  const ret = await baseAdapter.post<any>('/v1/merchant/CreateMerchant', data);
  return ret?.data?.data[0];
};

export const updateMerchant = async (data: Partial<IMerchant>) => {
  const ret = await baseAdapter.post('/v1/merchant/UpdateMerchant', data);
  return ret?.data;
};

export const deleteMerchant = async (data: Partial<IMerchant>) => {
  const ret = await baseAdapter.post<any>('/v1/merchant/DeleteMerchant', data);
  return ret?.data;
};

export const addBrand = async (data: Partial<IBrand>) => {
  const ret = await baseAdapter.post<any>('/v1/brand/add-brand', data);
  return ret?.data;
};

export const updateBrand = async (data: Partial<IBrand>) => {
  const ret = await baseAdapter.put('/v1/brand/update', data);
  return ret?.data;
};

export const matchBrand = async (data: Partial<IBrand>) => {
  const ret = await baseAdapter.put('/v1/brand/match', data);
  return ret?.data;
};

export const searchCatalogs = async () => {
  const ret = await baseAdapter.get<ICatalogRes>('/v1/catalog/gets');
  return ret?.data;
};

export const addCatalog = async (data: Partial<ICatalog>) => {
  const ret = await baseAdapter.post<any>('/v1/catalog/add', data);
  return ret?.data;
};

export const updateCatalog = async (data: Partial<ICatalog>) => {
  const ret = await baseAdapter.put('/v1/catalog/update', data);
  return ret?.data;
};

export const matchCatalog = async (data: Partial<ICatalog>) => {
  const ret = await baseAdapter.put('/v1/catalog/match', data);
  return ret?.data;
};

export const synctoERP = async (data: {
  MASTER_TYPE: 'BRAND' | 'CATALOG' | 'PRODUCT';
}) => {
  const ret = await baseAdapter.post('/v1/master/sync', data);
  return ret?.data;
};
